import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { downloadPendingFeesPDF } from "./DownloadPendingFeesPDF";

const Pending_Fees = () => {

  const [selectedSection, setSelectedSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);
  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState();
  const [ddlDivisions, setDdlDivisions] = useState([]);
  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [selectedPendFrom, setSelectedPendFrom] = useState();
  
  const [reportData, setReportData] = useState([]);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

      const std = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
      setDdlStds(std.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);


    } catch (err) {
      console.error(err);
    }

  };

  /// To Populate Standard on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlStds([]);
        setDdlDivisions([]);
        if (selectedSection) {
          const std = await axios.get(`${BASE_URL}/api/ddl_standards`, {params: {p_Section_Id: selectedSection}});
          setDdlStds(std.data);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [selectedSection]);

  /// To Populate Division on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlDivisions([]);
        if (selectedStd) {
          const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: selectedStd } });
          setDdlDivisions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [selectedStd]);

  const selectedStdName = ddlStds.find(std => std.std_id === Number(selectedStd))?.std_name || "";
  const selectedDivName = ddlDivisions.find(div => div.div_id === Number(selectedDiv))?.div_name || "";

  // Fetch report
  const handleRunReport = async () => {

    if (!selectedYear1 || selectedYear1 === '') {
      toast.error("Please select Academic Year.");
      return;      
    } else if (!selectedPendFrom || selectedPendFrom === '') {
      toast.error("Please select Pending From.");
      return;      
    }

    try {

      setReportData([]);

      const res = await axios.get(`${BASE_URL}/api/rpt_pending_fees`, {
        params: {
          p_year1: selectedYear1, 
          p_section_id: selectedSection, 
          p_std_id: selectedStd,
          p_div_id: selectedDiv,
          p_year1: selectedYear1,
          p_pend_from: selectedPendFrom
        }
      });

      if (res.data.length > 0) {
        setReportData(res.data);
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }

    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  };

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  ///// Start : PDF Download
  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    downloadPendingFeesPDF({
        reportData,
        selectedYear1,
        selectedStdName,
        selectedDivName
    });

  };
  //// End Pdf download

  const grandTotal = reportData.reduce(
    (sum, item) => sum + Number(item.pending_amount || 0),
    0
  );

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Academic Year 
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1}
                onChange={(e) => setSelectedYear1(e.target.value)} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}> Section 
              </InputGroup.Text>

              <select className="form-select" name="selectedSection" 
                value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)} >
                <option value="">Select</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Standard
              </InputGroup.Text>
              <select className="form-select"
                      name="selectedStd" value={selectedStd} onChange={(e) => setSelectedStd(e.target.value)} >
                <option value="">--Select Standard--</option>
                {ddlStds.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>Division
              </InputGroup.Text>
              <select className="form-select" name="selectedDiv"
                value={selectedDiv} onChange={(e) => setSelectedDiv(e.target.value)} >
                <option value="">-- Select Division --</option>
                {/* <option value="0">All Divisions</option> */}
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}
              </select>
            </InputGroup>

          </Col>

        </Row>

        <Row className="mt-3">

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Pending From
              </InputGroup.Text>
              <select className="form-select" name="selectedPendFrom"
                value={selectedPendFrom} onChange={(e) => setSelectedPendFrom(e.target.value)} >
                <option value="">-- Select Pending From --</option>
                <option value="1">Installment-1</option>
                <option value="2">Installment-2</option>
                <option value="3">Installment-3</option>
                <option value="4">Installment-4</option>
                <option value="5">Installment-5</option>
                <option value="6">Installment-6</option>
              </select>
            </InputGroup>

          </Col>

          <Col md={8} className="d-flex justify-content-end">

            <Button variant="primary" className="ms-2"
              disabled={reportData.length === 0} onClick={handleDownloadPDF} > Download PDF
            </Button>
            {/* <Button variant="success" className="ms-2"
              onClick={handleDownloadExcel}
              disabled={reportData.length === 0}> Download Excel
            </Button> */}
            <Button variant="success" onClick={handleRunReport} className="ms-2">
              Run Report
            </Button>          
          </Col>

        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                {/* <th style={{ textAlign: 'center', width: '3%' }}>#</th> */}
                {/* <th>Notice Type</th> */}
                <th style={{ textAlign: 'center', width: '5%' }} >Section </th>
                <th style={{ textAlign: 'center', width: '8%' }} >Std / Div </th>
                <th style={{ textAlign: 'center', width: '6%' }} >GR No. </th>
                <th style={{ textAlign: 'left', width: '40%' }} >Student Name </th>
                <th style={{ textAlign: 'center', width: '12%' }} >Pending From</th>
                <th style={{ textAlign: 'right', width: '10%' }} >Pending Amount</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                (() => {
                  let currentStdDiv = "";
                  let stdDivTotal = 0;

                  return (
                    <>
                      {reportData.map((n, idx) => {
                        const rows = [];

                        // If std_div changes, print previous group's total
                        if (currentStdDiv && currentStdDiv !== n.std_div) {
                          rows.push(
                            <tr
                              key={`total-${currentStdDiv}`}
                              style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}
                            >
                              <td colSpan="5" style={{ textAlign: "left" }}>
                                Total Pending Fees For ({currentStdDiv})
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {formatAmount(stdDivTotal)}
                              </td>
                            </tr>
                          );

                          stdDivTotal = 0;
                        }

                        currentStdDiv = n.std_div;
                        stdDivTotal += Number(n.pending_amount || 0);

                        // Student row
                        rows.push(
                          <tr key={idx}>
                            <td style={{ textAlign: "center" }}>{n.sect_prefix}</td>
                            <td style={{ textAlign: "center" }}>{n.std_div}</td>
                            <td style={{ textAlign: "center" }}>{n.gr_no}</td>
                            <td style={{ textAlign: "left" }}>{n.stud_name}</td>
                            <td style={{ textAlign: "center" }}>{n.pend_from}</td>
                            <td style={{ textAlign: "right" }}>
                              {formatAmount(n.pending_amount)}
                            </td>
                          </tr>
                        );

                        // Last std_div total
                        if (idx === reportData.length - 1) {
                          rows.push(
                            <tr
                              key={`total-last`}
                              style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}
                            >
                              <td colSpan="5" style={{ textAlign: "left" }}>
                                Total Pending Fees For ({currentStdDiv})
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {formatAmount(stdDivTotal)}
                              </td>
                            </tr>
                          );

                          // Grand Total
                          rows.push(
                            <tr
                              key="grand-total"
                              style={{
                                backgroundColor: "#d1ecf1",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                            >
                              <td colSpan="5" style={{ textAlign: "left" }}>
                                Grand Total
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {formatAmount(grandTotal)}
                              </td>
                            </tr>
                          );
                        }

                        return rows;
                      })}
                    </>
                  );
                })()
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody>

            {/* <tbody>
              {reportData.length > 0 ? (
                reportData.map((n, idx) => (
                  <tr key={n.irn}>
                    <td style={{ textAlign: 'center' }}> {n.sect_prefix} </td>
                    <td style={{ textAlign: 'center' }}> {n.std_div} </td>
                    <td style={{ textAlign: 'center' }}> {n.gr_no} </td>
                    <td style={{ textAlign: 'left' }} >{n.stud_name}</td>
                    <td style={{ textAlign: 'center' }}> {n.pend_from} </td>
                    <td style={{ textAlign: 'right' }}> {formatAmount(n.pending_amount)} </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody> */}
          </table>
        </div>
      </Card>

    </Container>
  );
};

export default Pending_Fees;
